module.exports = __webpack_public_path__ + "static/chooseMystery-2dec810ac08cca066346c6557628c577.jpg";